const notify = useNotify()
const { copy, isSupported, copied } = useClipboard()

export function useCopyToClipboard() {
  /**
   * @goal Copy text to clipboard.
   * @param text {string}
   * @param message {string} Successful state message to notify user
   * @param notification {boolean} Decide showing notification after copied
   */
  async function copyToClipboard(
    text: string,
    message?: string,
    notification: boolean = true,
  ) {
    if (!isSupported) return console.warn('Clipboard not supported')
    await copy(text)
    if (copied.value && notification) {
      notify.success(message || 'Copied successfully')
    }
    return copied.value
  }

  return { copyToClipboard }
}
